// src/utils/userSigUtils.js
// 登录成功后24小时 腾讯的userSign过期 而我们接口的token过期时间为7天 所以登录成功后 进行一个倒计时 
// 当超过24小时后重新获取一下usersign   为了兼容怕倒计时不准确的问题  特意设置为23小时
// 重新放到缓存中
import { getTencentUserSig } from "@/api/login";
import myJsTools from "@/utils/myJsTools";

export async function getUserSig() {
  const userID = myJsTools.getItem("docAllInfo") ? myJsTools.getItem("docAllInfo")?.docId : '';
  try {
    const res = await getTencentUserSig({ userId: userID });

    const config = {
      userID: res.data.userId,
      userSig: res.data.userSig,
      SDKAppID: res.data.sdkAppId
    };

    const currentTime = new Date().getTime(); // 当前时间戳
    const expirationTime = currentTime + 23 * 64 * 64 * 1000;

    myJsTools.setItem('loginTime', currentTime);
    myJsTools.setItem('expirationTime', expirationTime);
    myJsTools.setItem('tencentInfo', config);
    return { success: true, data: config };
  } catch (error) {
    console.error("获取腾讯用户签名失败：", error);
    return { success: false, error };
  }
}
